<div class="d-flex justify-content-between align-items-center" mat-dialog-title>
    <h1 class="condensed dialog-title">Exporteer delen</h1>
</div>
<div class="dialog-content flex-column" mat-dialog-content>
    <div class="w-100">
        @if (!exporting()) {
            <div class="pb-3">
                <p>Exporteer alle delen naar een Excel document.</p>
                @for (status of statuses(); track status.id; let i = $index) {
                    <div>
                        <mat-checkbox
                            [(ngModel)]="filter['status_' + status.id]"
                            [disabled]="filter['status_' + status.id + '_disable']"
                            [value]="status.id"
                            color="primary">
                            <span [innerHTML]="status['img'] | safeHtml"></span>
                            {{status.name}}
                            @if (statusCounts().has(status.id)) {
                                ({{statusCounts().get(status.id)}})
                            }
                        </mat-checkbox>
                    </div>
                }
            </div>
        } @else {
            <div class="w-100">
                Bezig met exporteren...
                <br><br>
                <mat-progress-bar class="w-100" mode="indeterminate"></mat-progress-bar>
                <br><br>
            </div>
        }
    </div>
</div>
<div class="d-flex flex-wrap pt-2 justify-content-between" mat-dialog-actions>
    <button (click)="onNoClick()" mat-button>Annuleren</button>
    <div class="spacer"></div>
    <button (click)="export()" cdkFocusInitial color="primary" mat-raised-button>Download Excel bestand</button>
</div>
